<template>
  <div class="def_wrap">
    <div class="type">
      <span class="title">2026年01月 申请报送表</span>
      <total-tax-info
          :current-ans="userAnswer"
      />
    </div>
    <div class="opt">
      <div class="left">
        <div>
          <el-space :size="20">
            <el-text size="large" class="mx-1" type="info">申报类型</el-text>
            <el-text size="large" class="mx-1" type="info">申报状态</el-text>
          </el-space>
        </div>
        <div style="margin: 10px 0;">
          <el-space :size="20">
            <el-text size="large" class="mx-1" :type="status">正常申报</el-text>
            <el-text size="large" class="mx-1" :type="status">
              {{ status == 'warning' ? "未申报" : "已申报" }}
            </el-text>
          </el-space>
        </div>
      </div>
      <div>
        <el-button type="primary" @click="send">发送申报</el-button>
      </div>
    </div>

    <el-table ref="tableRef" :data="resDataList" style="width: 100%" border>
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column prop="name" label="报表名称"/>

      <el-table-column prop="person" label="纳税人数"/>

      <el-table-column prop="Answer_CurrentIncome" label="累计收入额"/>

      <el-table-column label="应扣缴税款" prop="Answer_ShouldTaxMount"/>

      <el-table-column label="已扣缴税款" prop="Answer_TheAmountTaxWithheld"/>

      <el-table-column prop="Answer_TaxCreditPayable" label="应补（退）税额"/>

      <el-table-column label="是否可申报">
        <template #default>
          <span>是</span>
        </template>
      </el-table-column>
    </el-table>
    <!--        <div class="next_step" v-if="status == 'success'" @click="setTab">
                下一步，缴纳税款>
            </div>-->
    <el-dialog
        v-model="dialogVisible"
        title="进度"
        width="500"
    >
      <div class="progress">
        <p style="padding: 8px 0;">正在发送，请稍后.....</p>
        <el-progress type="line" :stroke-width="20" :percentage="percentage"/>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import {openBus} from '@/views/examCenter/tax/bus'
import {ElMessage} from 'element-plus'
import {useTaxStore} from '@/store/modules/tax.js'
import {computed, nextTick, onMounted} from 'vue';
import Big from "big.js";
import TotalTaxInfo from "./totalTaxInfo.vue";
import {usePersonTaxSummary} from "./fourStatistCommon.js";

const taxStore = useTaxStore()
const {userAnswer} = storeToRefs(taxStore);
const percentage = ref(0)
const dialogVisible = ref(false)
const tableRef = ref()
const currentQa = inject('provideCurrentQa');

const send = () => {
  const rows = getSelectionRows()
  if (rows.length == 0) {
    return ElMessage({
      message: '请选择申报种类',
      type: 'warning',
    })
  }
  if (rows.length != resDataList.value.length) {
    return ElMessage({
      message: '请全选申报种类',
      type: 'warning',
    })
  }
  dialogVisible.value = true;
  nextTick(() => {
    start()
  })

}
const status = ref('warning')
//获取选中
const getSelectionRows = () => {
  let rows = tableRef.value.getSelectionRows();
  console.log(rows)
  return rows
}
let timer = null
const start = () => {
  timer = setInterval(() => {
    percentage.value = percentage.value + 10;
    if (percentage.value >= 110) {
      stop()
    }
  }, 500)
}

const stop = () => {
  clearInterval(timer)
  dialogVisible.value = false;
  percentage.value = 0;
  ElMessage({
    showClose: true,
    message: '申请成功',
    type: 'success',
    offset: 300
  })
  status.value = 'success'
  nextTick(() => {
    setTab()
  })
}
const setTab = () => {
  openBus.emit({key: '7'})
}

const {resDataList} = usePersonTaxSummary(userAnswer.value)

onMounted(() => {
})
</script>

<style lang="scss" scoped>
.def_wrap {
  width: 100%;
  height: 100%;
  position: relative;

  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      color: #979494;

      span {
        margin-left: 6px;
      }
    }

    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
    }
  }

  .info {
    padding: 10px 0;
  }

  .opt {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  :deep(.el-table) {
    --el-table-header-bg-color: #f8f9fa;
  }

  .progress {
    :deep(.el-progress) {
      .el-progress-bar__outer {
        border-radius: 0px;

        .el-progress-bar__inner {
          border-radius: 0px;
        }
      }
    }
  }

  .next_step {
    position: absolute;
    right: 10px;
    bottom: 20px;
    color: var(--el-color-warning);
    font-size: 16px;
    padding: 24px;
    border: 1px solid #eee;
    cursor: pointer;
    background-color: var(--el-color-warning-light-9);
  }
}
</style>
